import React, { Fragment, useState, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Image from 'common/components/Image';
import Heading from 'common/components/Heading';
import Text from 'common/components/Text';
import Button from 'common/components/Button';
import GlideCarousel from 'common/components/GlideCarousel';
import GlideSlide from 'common/components/GlideCarousel/glideSlide';
import { CircleLoader } from '../interior.style';
import BannerWrapper, {
  Container,
  ContentArea,
  ButtonGroup,
  CarouselArea,
  HighlightedText,
} from './banner.style';

const Banner = () => {
  const data = useStaticQuery(graphql`
    query {
      interiorJson {
        bannerData {
          discount
          discountLabel
          title
          text
          carousel {
            id
            title
            thumb_url {
              publicURL
            }
            link
          }
        }
      }
    }
  `);

  const { title, text, carousel, discount, discountLabel } =
    data.interiorJson.bannerData;

  const glideOptions = {
    type: 'carousel',
    perView: 3,
    gap: 20,
    breakpoints: {
      1200: {
        perView: 2,
      },
      667: {
        perView: 2,
      },
      480: {
        perView: 1,
      },
    },
  };

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
  }, []);

  return (
    <BannerWrapper>
      <Container>
        <ContentArea>
          <Fade bottom delay={30}>
            <Heading as="h1" content={title} />
            <Text content={text} />
            <HighlightedText>
              {' '}
              {discountLabel}
              <strong>{discount}</strong>
            </HighlightedText>
            <ButtonGroup>
              <a href="#feature">
                <Button
                  type="button"
                  href="#about"
                  colors="primaryWithBg"
                  title="POZNAJ MNIE"
                />
              </a>
              <a href="https://booksy.com/pl-pl/90489_twoj-fizjo-gabinet-rehabilitacji_fizjoterapia_23280_lodz">
                <Button
                  type="button"
                  href="#about"
                  colors="secondaryWithBg"
                  title="ZAREZERWUJ"
                />
              </a>
              <a href="https://www.google.com/maps/dir/?api=1&destination=51.727497%2C19.423353&fbclid=IwAR2rURuitaM7z-mjYtffj2ovOqe2KH3wTtdbN0b2-9onDBecv2KTKcuMfpU">
                <Button
                  type="button"
                  title="Jak dojechać?"
                  variant="textButton"
                  icon={<i className="flaticon-next" />}
                />
              </a>
            </ButtonGroup>
          </Fade>
        </ContentArea>
        {/* End of content section */}

        <CarouselArea>
          {loading ? (
            <GlideCarousel
              carouselSelector="interior_carousel"
              options={glideOptions}
              nextButton={<span className="next_arrow" />}
              prevButton={<span className="prev_arrow" />}
            >
              <Fragment>
                {carousel.map((item) => (
                  <GlideSlide key={`carousel_key${item.id}`}>
                    <a href={item.link} className="item_wrapper">
                      <Image
                        src={item.thumb_url.publicURL}
                        alt={item.title}
                        className="carousel_img"
                      />
                      <Heading as="h4" content={item.title} />
                    </a>
                  </GlideSlide>
                ))}
              </Fragment>
            </GlideCarousel>
          ) : (
            <CircleLoader>
              <div className="circle"></div>
              <div className="circle"></div>
            </CircleLoader>
          )}
        </CarouselArea>
        {/* End of carousel section */}
      </Container>
    </BannerWrapper>
  );
};

export default Banner;
